import Vue from 'vue'
import vueToast from './index.vue'

let ToastTem = Vue.extend(vueToast)
let instance
let timer = null

let toast = (options) => {
    if (!instance) {
      instance = new ToastTem()
      instance.vm = instance.$mount()
      document.body.appendChild(instance.vm.$el)
    }
    console.log(options)
    if (timer) {
      clearTimeout(timer)
      timer = null
      instance.show = false
      instance.message = ''
    }
    let time = 2000
    if (typeof options === 'string') {
      instance.message = options
    } else if (typeof options === 'object') {
      let {message, time} = options
      instance.message = message
      time = time || 2000
    } else {
      return
    }
    instance.show = true
    timer = setTimeout(() => {
      instance.show = false
      clearTimeout(timer)
      timer = null
      instance.message = ''
    }, time)
  }
  
  toast.close = () => {
    if (timer) {
      clearTimeout(timer)
      timer = null
      instance.show = false
      instance.message = ''
    }
  }

export default toast

toast.install = (Vue) => {
    Vue.prototype.$toast = toast
}


// WEBPACK FOOTER //
// ./src/plugins/Toast/index.js